export default __webpack_public_path__ + "static/tt-norms-pro-extrabold-cf605f550a50cf57c563c4a2158d4a45.woff2";